module.exports = __webpack_public_path__ + "img/首页-banner_03.61a45fc6.png";